import PercentageBarGraph from "@/reports/components/PercentageBarGraph";
import { StandardCategory } from "@/types/models/StandardCategory.interface";
import { TableData } from "../ReadingSkillsDataTable";
import {
  containerCss,
  containerWithoutBarGraphCss,
  headerTextCss,
  PercentageBarGraphContainerCss,
} from "./TableHeaderCell.style";

interface TableHeaderCellProps {
  data?: TableData | undefined;
  readingSkill: StandardCategory;
  label?: string | undefined;
}

const TableHeaderCell = ({
  data,
  readingSkill,
  label,
}: TableHeaderCellProps) => {
  const dataForReadingSkill = data ? data[readingSkill.slug] : null;

  if (!dataForReadingSkill)
    return <div css={headerTextCss}>{readingSkill.text}</div>;

  return (
    <div
      css={[containerCss, !dataForReadingSkill && containerWithoutBarGraphCss]}
    >
      <div css={headerTextCss}>{readingSkill.text}</div>
      {dataForReadingSkill && (
        <div css={PercentageBarGraphContainerCss}>
          <PercentageBarGraph
            // @ts-expect-error Property 'average_quiz_score' does not exist on type '{}'.
            value={dataForReadingSkill?.percentageValue}
            label={label ?? null}
            overrideWithGreen={{
              bar: true,
              label: true,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default TableHeaderCell;
